import { forwardRef } from 'react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var SimpleCheckbox = /*#__PURE__*/forwardRef(function (props, ref) {
  return _jsxs("label", {
    sx: {
      display: 'block'
    },
    children: [_jsx("input", {
      name: props.name,
      ref: ref,
      sx: {
        appearance: 'none',
        position: 'absolute',
        '&:checked + span': {
          '&::before': {
            transition: 'background-color 200ms, border-color 200ms'
          }
        },
        opacity: 0,
        variant: "elements.input.checkbox.variants.normal"
      },
      type: "checkbox",
      defaultChecked: props.defaultChecked,
      value: props.value,
      onBlur: props.onBlur
    }), _jsx("span", {
      sx: {
        variant: 'elements.simple-checkbox.base-no-border'
      },
      children: props.label
    })]
  });
});
export default SimpleCheckbox;
//# sourceMappingURL=index.js.map